import { Component, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { User } from '../../models/User';
import { HelperService } from '../../services/helper.service';
import { UserService } from '../../services/userService';
import { TestService } from '../../services/test.service';
import { SourceService } from '../../services/source.service';
import { Test } from '../../models/Test';
import { Source } from '../../models/Source';
import { Site } from '../../models/Site';
import { Observable } from 'rxjs/Observable';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.css']
})
export class CreateUserComponent implements OnInit {
  User: User;
  Tests: Test[];
  Sources: Source[];
  Sites: Site[];
  selectedTest: Test;
  selectedSource: Source;
  isNewUser: boolean = true;
  UserId: string;
  errorMessage: string;
  emailInUse: boolean = false;
  myControl: FormControl = new FormControl();
  //testControl: FormControl = new FormControl();
  constructor(private _helper: HelperService,
    private userService: UserService,
    //private testService: TestService,
    private sourceService: SourceService,
    private formBulder: FormBuilder,
    private activatedRoute: ActivatedRoute, private router: Router) {

  }

  filteredOptions: Observable<Source[]>;
  newUserForm: FormGroup;

  ngOnInit() {
    this.User = new User();
    //this.User.Tests = [];
    this.User.Sources = [];

    this.buildForm();
    this.getSites();
    this.activatedRoute.queryParams.subscribe(params => {
      let userid = params['userId'];
      if (userid) {
        this.UserId = userid;
        this.isNewUser = false;
        this.userService.getUserById(userid).subscribe(data => {
          this.User = data;
          this.newUserForm.reset();
          this.buildForm();
        });
      }
    });
    this.newUserForm.controls['Email'].valueChanges.subscribe(email => {
      if (!this.newUserForm.controls['Email'].invalid) {
        this.userService.IsEmailInUse(email).subscribe(data => {
          this.emailInUse = data;
        })
      }
    });


    this.myControl.valueChanges.subscribe(filter => {
      if (filter.length >= 2) {
        this.loadSources(filter);
      }
    })
  }

  loadSources(sourceCode: string) {
    this.sourceService.filterSources(this.User.Site, sourceCode)
      .subscribe((data: Source[]) => {
        this.Sources = data.map(src => ({ UserSourceId: src.UserSourceId, Id: src.Id, SourceCode: src.SourceCode, SourceName: src.SourceName, Site: src.Site }));
        }
      );
  }

  buildForm() {
    this.newUserForm = this.formBulder.group({
      Email: [this.User.Email, [Validators.required, Validators.pattern("[a-zA-Z0-9!#$%&' * +/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?")]],
      FirstName: [this.User.FirstName, Validators.required],
      LastName: [this.User.LastName, Validators.required],
      Tel: [this.User.Tel, Validators.required],
      CanViewResults: [this.User.CanViewResults],
      CanOrderKits: [this.User.CanOrderKits],
      CanRequest: this.User.CanRequest,
      CanSeeAllSiteResults: [this.User.CanSeeAllSiteResults],
      Site: [this.User.Site, Validators.required],
      Clinician: [this.User.Clinician, Validators.maxLength(10)]
    });
  }

  removeSource(source: Source) {
    this.User.Sources = this._helper.RemoveItemFromArray(this.User.Sources, source, item => { return item.Id == source.Id; });
  }

  canAddSource(source: Source): boolean {
    if (source) {
      return !this._helper.Exists(this.User.Sources, (item) => {
        let result = source.SourceCode == item.SourceCode;
        return result;
      });
    }
  }

  addSource() {
    if (this.canAddSource(this.selectedSource)) {
      this.User.Sources.push(this.selectedSource);
      this.myControl.setValue('');
    }
  }

  selectSource(event,  source) {
    this.selectedSource = source;
    //this.testControl.setValue('');
    //this.Tests = [];
  }

  onSiteChange(event) {
    this.User.Site = event.target.value;
    console.log("site ", this.User.Site, event.target.value);
    if (this.User.Site == 1 || this.User.Site == 2) {
      console.log(this.User.Site);
      this.User.CanSeeAllSiteResults = false;
      this.newUserForm.controls['CanSeeAllSiteResults'].setValue(false);
    }
    console.log(this.User.CanSeeAllSiteResults);
  }
  
  checkSite() {
    console.log(this.User.Site == 2);
    return this.User.Site == 2;
  }

  createUser(userData) {
    //console.log(this.newUserForm.controls['CanViewResults']);
    userData.CanViewResults = this.newUserForm.controls['CanViewResults'].value ? true : false
    userData.CanOrderKits = this.newUserForm.controls['CanOrderKits'].value ? true : false
    userData.CanRequest = this.newUserForm.controls['CanRequest'].value ? true : false
    userData.CanSeeAllSiteResults = this.newUserForm.controls['CanSeeAllSiteResults'].value ? true : false
    if (this.isNewUser) {
      userData.Sources = this.User.Sources;;
        this.userService.addUser(userData).subscribe(id => {
            this.router.navigate(['Admin/users']);
        });
    }
    else {
      userData.Id = this.UserId;
      userData.Sources = this.User.Sources;;
      this.userService.updateUser(userData).subscribe(data => { this.router.navigate(['Admin/users']);});
    }
  }

  cancel() {
    this.newUserForm.reset();
    this.router.navigate(['Admin/users']);
  }
  
  getSites() {
    this.Sites = [];
    this.sourceService.getSites().subscribe(sites => { this.Sites = sites; });
  }

  onCanSeeAllSiteResultsChange() {
    this.User.CanSeeAllSiteResults = !this.User.CanSeeAllSiteResults;
  }

  onCanRequestChange() {
    this.User.CanRequest = !this.User.CanRequest;
  }

  isCanSeeAllSiteResultsEnabled() {
    var isEnabled = this.User.Site == 4 || this.User.Site == 5;
    //console.log("isEnabled", isEnabled);
    return isEnabled;
  }

  isUserFormValid() {
    //console.log("isUserValid : ", this.User);
    if (!this.newUserForm.valid) {
      return false;
    }

    else if (this.emailInUse) {
      this.errorMessage = 'This email is in use';
      return false;
    }
    else if (this.User.Site == undefined) {
      this.errorMessage = 'You should assign a site.';
      return false;
    }

    else if (this.User.Sources.length == 0 && this.User.CanRequest) {
      this.errorMessage = 'You should assign at least one source.';
      return false;
    }

    else if (this.User.Sources.length == 0 && !this.User.CanSeeAllSiteResults) {
      this.errorMessage = 'You should assign at least one source.';
      return false;
    }

    this.errorMessage = null;
    return true;
  }
}
